import { COLOR_NEUTRAL_300 } from '@alltrails/denali/tokens';
import { createCircleMarker, getCircleMarkerSize } from './svgMarkerComponents';

const innerDiameter = 10;
export const size = getCircleMarkerSize(innerDiameter);
const handleSvg = createCircleMarker({ imageName: 'handle', innerDiameter, innerFill: COLOR_NEUTRAL_300 });

export default handleSvg;
